
import React, { PureComponent } from 'react'

import Panel from 'app/Components/Survey/Panel'
import Submit from 'app/Components/Survey/Submit'

export default class Message extends PureComponent {

  render() {
    const question = 'Leave us a message'
    const title = 'message'
    return (
      <div>
        <Panel {...this.props} title={title} question={question} nextQuestion={Submit} buttonText='SUBMIT' />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./form/questions/Message.js
 **/